import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7158d3be")

_pushScopeId("data-v-7158d3be")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("场景管理")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = { class: "scene-management" }
const _hoisted_5 = {
  key: 0,
  class: "table-div"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "table-div"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "table-div"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "table-div"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "table-div"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "dialogTitle" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "新增场景", -1)
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确 认")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_main = _resolveComponent("el-main")
  const _component_Paging = _resolveComponent("Paging")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_breadcrumb, {
                "separator-class": "el-icon-arrow-right",
                class: "PosTitle"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withId(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = true)),
                    type: "primary",
                    size: "small",
                    class: "btnStyle",
                    disabled: _ctx.get_is_super
                  }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider),
              _withDirectives(_createVNode("div", _hoisted_4, [
                _createVNode(_component_el_card, { class: "tableMinH" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_table, {
                      size: "small",
                      data: _ctx.getProjectScenes(_ctx.search),
                      style: {"width":"100%"},
                      "header-cell-class-name": "tabelHeader"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          label: "id",
                          prop: "id"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "scene",
                          label: "项目原始场景id"
                        }, {
                          default: _withId((scope) => [
                            (scope.row.isEdit)
                              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                                  _createVNode("input", {
                                    type: "text",
                                    class: "table-input",
                                    id: 'original_scene_id' + scope.row.id,
                                    value: scope.row.original_scene_id
                                  }, null, 8, ["id", "value"])
                                ]))
                              : (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(scope.row.original_scene_id), 1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "scene",
                          label: "场景名"
                        }, {
                          default: _withId((scope) => [
                            (scope.row.isEdit)
                              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                                  _createVNode("input", {
                                    type: "text",
                                    class: "table-input",
                                    id: 'chinese' + scope.row.id,
                                    value: scope.row.chinese
                                  }, null, 8, ["id", "value"])
                                ]))
                              : (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(scope.row.chinese), 1))
                          ]),
                          _: 1
                        }),
                        (_ctx.project == 34)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              label: "性别"
                            }, {
                              default: _withId(({row}) => [
                                (!row.isEdit)
                                  ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.genderOptions[row.gender]), 1))
                                  : (_openBlock(), _createBlock(_component_el_select, {
                                      key: 1,
                                      modelValue: row.gender,
                                      "onUpdate:modelValue": ($event: any) => (row.gender = $event),
                                      size: "mini",
                                      id: 'gender' + row.id
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_option, {
                                          label: "默认",
                                          value: 0
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "男",
                                          value: 1
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "女",
                                          value: 2
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "id"]))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.project == 42)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 1,
                              label: "旧武器"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_checkbox, {
                                  modelValue: scope.row.oldWeapons,
                                  "onUpdate:modelValue": ($event: any) => (scope.row.oldWeapons = $event),
                                  disabled: !scope.row.isEdit
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.project == 57 || _ctx.project == 34)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 2,
                              label: "皮肤等级",
                              prop: "level"
                            }, {
                              default: _withId((scope) => [
                                (scope.row.isEdit)
                                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                                      _createVNode("input", {
                                        type: "text",
                                        class: "table-input",
                                        id: 'level' + scope.row.id,
                                        value: scope.row.level
                                      }, null, 8, ["id", "value"])
                                    ]))
                                  : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(scope.row.level), 1))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.localProject == 57)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 3,
                              label: "皮肤品质",
                              prop: "quality"
                            }, {
                              default: _withId((scope) => [
                                (scope.row.isEdit)
                                  ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                      _createVNode("input", {
                                        type: "text",
                                        class: "table-input",
                                        id: 'quality' + scope.row.id,
                                        value: scope.row.quality
                                      }, null, 8, ["id", "value"])
                                    ]))
                                  : (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(scope.row.quality), 1))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_table_column, {
                          label: "创建人",
                          prop: "creator"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "创建时间",
                          prop: "created"
                        }),
                        (_ctx.localProject == 59)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 4,
                              label: "排序id",
                              prop: "order_id"
                            }, {
                              default: _withId((scope) => [
                                (scope.row.isEdit)
                                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                      _createVNode("input", {
                                        type: "text",
                                        class: "table-input",
                                        id: 'order_id' + scope.row.id,
                                        value: scope.row.order_id
                                      }, null, 8, ["id", "value"])
                                    ]))
                                  : (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(scope.row.order_id), 1))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_table_column, { align: "right" }, {
                          header: _withId(() => [
                            _createVNode(_component_el_input, {
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearch())),
                              modelValue: _ctx.search,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = $event)),
                              size: "mini",
                              placeholder: "输入关键字搜索"
                            }, null, 8, ["modelValue"])
                          ]),
                          default: _withId((scope) => [
                            _createVNode(_component_el_space, { wrap: "" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  disabled: _ctx.get_is_super,
                                  onClick: ($event: any) => (_ctx.handleEdit(scope.row, _ctx.sceneForm)),
                                  type: scope.row.info
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(scope.row.handleEditText), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick", "type"]),
                                _createVNode(_component_el_popconfirm, {
                                  onConfirm: ($event: any) => (_ctx.handleDeleteScene(scope.row, _ctx.sceneForm)),
                                  title: scope.row.handleConfirmText
                                }, {
                                  reference: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      disabled: _ctx.get_is_super,
                                      type: scope.row.isDanger
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(scope.row.handleDeleteText), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "type"])
                                  ]),
                                  _: 2
                                }, 1032, ["onConfirm", "title"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                })
              ], 512), [
                [_directive_loading, _ctx.loading]
              ]),
              _createVNode(_component_el_dialog, {
                width: "615px",
                modelValue: _ctx.dialogVisible,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogVisible = $event))
              }, {
                title: _withId(() => [
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_divider)
                  ])
                ]),
                footer: _withId(() => [
                  _createVNode("span", _hoisted_18, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "info",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogVisible = false))
                    }, {
                      default: _withId(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      onClick: _ctx.submitForm
                    }, {
                      default: _withId(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    "label-position": "top",
                    size: "small"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        label: "场景名称",
                        size: "small",
                        style: {"width":"40%"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            placeholder: "请输入场景名称",
                            modelValue: _ctx.addSceneForm.chinese,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.addSceneForm.chinese = $event)),
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "游戏场景id",
                        size: "small",
                        style: {"width":"40%","margin-left":"30px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            placeholder: "请输入游戏场景id",
                            modelValue: _ctx.addSceneForm.original_scene_id,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.addSceneForm.original_scene_id = $event)),
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.project == 42)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "旧武器",
                            class: "mt-3",
                            style: {"width":"200px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.addSceneForm.oldWeapons,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.addSceneForm.oldWeapons = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.project == 34)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "性别",
                            class: "mt-3"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.addSceneForm.gender,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.addSceneForm.gender = $event)),
                                size: "mini",
                                style: {"width":"100%"}
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_option, {
                                    label: "默认",
                                    value: 0
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "男",
                                    value: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "女",
                                    value: 2
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_footer, { class: "footerStyle" }, {
            default: _withId(() => [
              _createVNode(_component_Paging, {
                onOnPaging: _ctx.onPaging,
                totalNum: _ctx.totalNum
              }, null, 8, ["onOnPaging", "totalNum"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})